import * as R from 'ramda';

import { resetTerms as resetJsonQueryTerms } from './helpers';
import { type TJsonQuery } from './types';

export function clearUndergroundTravel(jsonQuery: TJsonQuery) {
  return (): TJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    nextJsonQuery = resetJsonQueryTerms(['only_foot', 'foot_min'])(nextJsonQuery);

    return nextJsonQuery;
  };
}
